export const oktaConfig = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || '0oadj4pyw5WppApYE1d7',
  issuer: process.env.REACT_APP_OKTA_ISSUER || 'https://argogroup.oktapreview.com',
  redirectUri: `${process.env.REACT_APP_BASE_URL}/implicit/callback`,
  postLogoutRedirectUri: `${process.env.REACT_APP_BASE_URL}/logout`,
  scopes: ['openid', 'profile', 'email', 'groups'],
  pkce: true,
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.read'],
  // FIXME: get a working scope for out own API to get a verifiable accessToken
  // scopes: ['api://eda96cc6-876b-499c-bf83-19bc4c491f5d/api.read'],
};
